if (!customElements.get('mf-product-information')) {
  customElements.define('mf-product-information', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-info-find-size]');
        if (trigger) {
          const entry = this.closest('.shopify-section')?.querySelector('[data-mf-open]');
          if (entry) entry.click();
          else this.querySelector('[data-info-error]').hidden = false;
        }
        const unit = event.target.closest('[data-info-unit]');
        if (unit) {
          this.querySelectorAll('[data-info-unit]').forEach(button => button.setAttribute('aria-pressed', String(button === unit)));
          this.querySelectorAll('[data-info-table]').forEach(table => { table.hidden = table.dataset.infoTable !== unit.dataset.infoUnit; });
        }
      }, { signal: this.controller.signal });
      if (this.dataset.kind === 'delivery') {
        const timeline = this.closest('.shopify-section')?.querySelector('mf-delivery-timeline');
        if (timeline) {
          const sync = () => {
            const format = (min, max) => this.dataset.daysLabel.replace('[range]', min === max ? min : min + '–' + max);
            this.querySelector('[data-info-dispatch]').textContent = format(timeline.dataset.processMin, timeline.dataset.processMax);
            this.querySelector('[data-info-transit]').textContent = format(timeline.dataset.transitMin, timeline.dataset.transitMax);
          };
          sync();
          this.observer = new MutationObserver(sync);
          this.observer.observe(timeline, { attributes: true, attributeFilter: ['data-process-min', 'data-process-max', 'data-transit-min', 'data-transit-max'] });
        }
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); }
  });
}
